import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { RELATED_PARTY_TYPES } from '../../constants';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: {
    principalType,
    principalNonUSPersonIdNumber,
    principalIsUSCitizen,
  },
} = loanFormModel;

export class PrincipalNonUSPersonIdNumberValidation
  implements ValidationSchema
{
  public name = principalNonUSPersonIdNumber.name;
  public label = principalNonUSPersonIdNumber.label;
  public dependsOn: string[] = [principalType.name, principalIsUSCitizen.name];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(principalType: string, principalIsUSCitizen: string, schema) {
    if (
      principalType === RELATED_PARTY_TYPES.INDIVIDUAL &&
      principalIsUSCitizen === 'No'
    ) {
      return schema
        .required(principalNonUSPersonIdNumber.requiredErrorMsg)
        .min(2);
    }
    return schema.transform(() => null);
  }
}
export default new Validation(new PrincipalNonUSPersonIdNumberValidation());
